import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGridSection() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const displayCategories = categories.slice(0, 12);

  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block text-xs font-medium text-primary-500 uppercase tracking-wider mb-3 border border-primary-200/60 rounded-full px-4 py-1.5">
            {t('categories.title')}
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 mb-3">
            {t('categories.subtitle')}
          </h2>
          <p className="text-base text-foreground-600 max-w-2xl mx-auto">
            {t('categories.description')}
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {displayCategories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative bg-background-50 rounded-lg p-5 md:p-6 hover:bg-primary-500 transition-all duration-300 cursor-pointer overflow-hidden"
            >
              <div className="relative z-10">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-background-100 flex items-center justify-center mb-4 group-hover:bg-background-50/20 transition-colors duration-300">
                  <i className={`${cat.icon} w-5 h-5 md:w-6 md:h-6 flex items-center justify-center text-foreground-700 group-hover:text-background-50 transition-colors duration-300`}></i>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-background-50 transition-colors duration-300">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500 mt-1 group-hover:text-background-50/70 transition-colors duration-300">
                  {t('category.all')}
                </p>
              </div>
              <div className="absolute bottom-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <i className="ri-arrow-right-up-line w-5 h-5 flex items-center justify-center text-background-50"></i>
              </div>
            </a>
          ))}

          <button
            onClick={() => navigate('/artykul/kakobuy-sheet-kompletny-przewodnik')}
            className="group relative bg-background-50 rounded-lg p-5 md:p-6 hover:bg-accent-500 transition-all duration-300 cursor-pointer overflow-hidden text-left"
          >
            <div className="relative z-10">
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-accent-100 flex items-center justify-center mb-4 group-hover:bg-background-50/20 transition-colors duration-300">
                <i className="ri-file-text-line w-5 h-5 md:w-6 md:h-6 flex items-center justify-center text-accent-600 group-hover:text-background-50 transition-colors duration-300"></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-background-50 transition-colors duration-300">
                {t('categories.articleCard')}
              </h3>
              <p className="text-xs text-foreground-500 mt-1 group-hover:text-background-50/70 transition-colors duration-300">
                {t('categories.articleDesc')}
              </p>
            </div>
            <div className="absolute bottom-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center text-background-50"></i>
            </div>
          </button>
        </div>

        <div className="mt-8 text-center">
          <div className="inline-flex flex-wrap items-center justify-center gap-2">
            <button
              onClick={() => navigate('/artykul/porownanie-spreadsheet-zakupowych')}
              className="px-4 py-2 rounded-full border border-secondary-200/60 bg-secondary-50 text-sm text-secondary-700 hover:bg-secondary-100 hover:border-secondary-300 transition-all duration-150 cursor-pointer whitespace-nowrap font-medium"
            >
              <i className="ri-scales-line w-4 h-4 flex items-center justify-center mr-1.5 inline-flex"></i>
              Porównanie Platform
            </button>
            <button
              onClick={() => navigate('/artykul/bezpieczne-korzystanie-ze-spreadsheet')}
              className="px-4 py-2 rounded-full border border-accent-200/60 bg-accent-50 text-sm text-accent-700 hover:bg-accent-100 hover:border-accent-300 transition-all duration-150 cursor-pointer whitespace-nowrap font-medium"
            >
              <i className="ri-shield-check-line w-4 h-4 flex items-center justify-center mr-1.5 inline-flex"></i>
              Poradnik Bezpieczeństwa
            </button>
            <button
              onClick={() => navigate('/artykul/kakobuy-spreadsheet-sneakersy-buty')}
              className="px-4 py-2 rounded-full border border-background-200/60 text-sm text-foreground-600 hover:bg-background-100 hover:border-background-300 transition-all duration-150 cursor-pointer whitespace-nowrap font-medium"
            >
              <i className="ri-footprint-line w-4 h-4 flex items-center justify-center mr-1.5 inline-flex"></i>
              Sneakersy i Buty
            </button>
            <button
              onClick={() => navigate('/artykul/kakobuy-spreadsheet-moda-odziez')}
              className="px-4 py-2 rounded-full border border-background-200/60 text-sm text-foreground-600 hover:bg-background-100 hover:border-background-300 transition-all duration-150 cursor-pointer whitespace-nowrap font-medium"
            >
              <i className="ri-t-shirt-line w-4 h-4 flex items-center justify-center mr-1.5 inline-flex"></i>
              Moda i Odzież
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}